import React, { Fragment } from 'react'

import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Skeleton } from '@material-ui/lab'

import LoadingBubbles from 'components/LoadingBubbles'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    opacity: 0.5,
    position: 'relative',
    height: 200,
    width: '100%',
  },
  bubbles: {
    position: 'absolute',
    top: 75,
    width: 150,
    alignSelf: 'center',
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  metricLabel: {
    width: 89,
    borderRadius: 6,
    backgroundColor: theme.palette.grey[300],
  },
  metric: {
    width: '100%',
    height: 26,
    borderRadius: 8,
    backgroundColor: theme.palette.grey[300],
  },
}))

const Loading = () => {
  const styles = useStyles()
  return (
    <Fragment>
      <Box
        className={styles.container}
        p={6}
      >
        <Box
          className={styles.metric}
          mb={4}
        />
        <Box
          className={styles.labelContainer}
          my={1}
        >
          <Typography variant="body2">
            <Skeleton className={styles.metricLabel} />
          </Typography>
          <Typography variant="body2">
            <Skeleton className={styles.metricLabel} />
          </Typography>
          <Typography variant="body2">
            <Skeleton className={styles.metricLabel} />
          </Typography>
          <Typography variant="body2">
            <Skeleton className={styles.metricLabel} />
          </Typography>
        </Box>
        <LoadingBubbles className={styles.bubbles} />
      </Box>
    </Fragment>
  )
}

export default Loading
